import { AccountDoc, AccountWhole } from 'lib/interfaces/database/account';
import _ from 'lodash';
import { AccountsService } from 'services/accounts';
import { create } from 'zustand';

interface State {
  data: AccountWhole[];
}

interface Actions {
  // server will force investorID to be set if run by an investor
  readonly load: (force?: boolean) => void;
  readonly create: (v: Partial<AccountDoc>) => Promise<boolean>;
  readonly update: (id: string, v: Partial<AccountDoc>) => Promise<boolean>;
}

interface Store extends State, Actions {}

const useAccountsStore = create<Store>((set, get) => {
  const service = AccountsService.getInstance();

  return {
    data: [],

    load: async (force) => {
      if (!force && get().data.length > 0) {
        console.debug('Skipped unforced load');
        return;
      }

      const results = await service.search({});

      if (results) {
        set({ data: results });
      }
    },

    create: async (v) => {
      const record = await service.create(v);

      if (record) {
        const nextData = _.clone(get().data);
        nextData.push(record);

        set({ data: nextData });
      }

      return !!record;
    },

    update: async (id, v) => {
      const record = await service.update(id, v);

      if (record) {
        const nextData = get().data.map((d) =>
          d.id === record.id ? record : d
        );

        set({ data: nextData });
      }

      return !!record;
    },
  };
});

export default useAccountsStore;
